import { trendList } from "@/mocks/home";

export default function TrendBoard() {
  const maxHeat = 1000;

  return (
    <section id="board" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-[1360px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="text-[11px] font-label tracking-[0.24em] text-primary-600">TREND BOARD</span>
          <h2 className="mt-2 font-heading text-3xl md:text-[2.4rem] font-black leading-tight text-foreground-950">
            热度榜
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-500">
            按讨论量、转发量与检索量综合计算，每 15 分钟更新一次。热搜会退潮，但时间线会留下来。
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {["综合", "讨论量", "转发量", "检索量"].map((tab, i) => (
              <button
                key={tab}
                type="button"
                className={`rounded-full px-4 py-1.5 text-xs font-label transition-colors cursor-pointer whitespace-nowrap ${
                  i === 0
                    ? "bg-foreground-950 text-background-50"
                    : "border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="border-t border-background-300">
            {trendList.map((item) => (
              <li
                key={item.rank}
                className="group flex items-center gap-4 md:gap-6 border-b border-background-200 py-4 hover:bg-background-100 transition-colors px-1"
              >
                <span
                  className={`w-8 shrink-0 font-heading text-center text-lg font-black tabular-nums ${
                    item.rank <= 3 ? "text-primary-600" : "text-foreground-400"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                    <span className="hidden sm:inline-block shrink-0 rounded-full bg-secondary-100 text-secondary-800 px-2 py-0.5 text-[10px] font-label">
                      {item.tag}
                    </span>
                  </div>
                  <div className="mt-2 h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                    />
                  </div>
                </div>
                <span className="w-14 shrink-0 text-right font-heading text-sm font-bold text-foreground-700 tabular-nums">
                  {item.heat}
                </span>
                <span className="w-5 shrink-0 flex justify-center">
                  <i
                    className={`text-base ${
                      item.change === "up" ? "ri-arrow-up-line text-primary-500" : "ri-arrow-down-line text-secondary-500"
                    }`}
                  />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}